import MarketStress from 'views/insights-toolbox/MarketStress';
import RollingReturns from 'views/insights-toolbox/RollingReturns';
import ValueAtRisk from 'views/insights-toolbox/ValueAtRisk';
import Drawdown from 'views/insights-toolbox/Drawdown';

import drawdown_ from 'assets/img/it-drawdown.png';
import marketstress_ from 'assets/img/it-market-stress.png';
import rollingreturns_ from 'assets/img/it-rolling-returns.png';
import valueaatrisk_ from 'assets/img/it-value-aat-risk.png';
import HorizontalLanding from 'components/HorizontalLanding';

export const meta = {
  path: '/it',
  title: 'Insights & Tools',
  component: Landing,
  items: [
    {
      title: 'Market Stress',
      path: '/market-stress',
      component: MarketStress,
      description: 'Compare performance versus a benchmark for discrete periods of historical market stress.',
      imgSrc: marketstress_,
      permission: 'it-market-stress',
    },
    {
      title: 'Drawdown',
      path: '/drawdown',
      component: Drawdown,
      description: 'Detailed analysis of historical drawdown experience.',
      imgSrc: drawdown_,
      permission: 'it-drawdown',
    },
    {
      title: 'Value At Risk',
      path: '/value-at-risk',
      component: ValueAtRisk,
      description:
        'Dynamic analysis and visualization of VaR over varying types, time windows, and confidence intervals.',
      imgSrc: valueaatrisk_,
      permission: 'it-value-at-risk',
    },
    {
      title: 'Rolling Returns',
      path: '/rolling-returns',
      component: RollingReturns,
      description: 'Dynamic analysis of returns over a series of rolling time windows.',
      imgSrc: rollingreturns_,
      permission: 'it-rolling-returns',
    },
  ],
};

export default function Landing({ session }) {
  return <HorizontalLanding meta={meta} session={session} />;
}
